import marker from "./marker";
import menuItem from "./menuItem";
import popup from "./popup";

export default `
${marker}
${menuItem}
${popup}
`;
